/**
 *
 * "common names in the Reports pages"
 *
 * @file   AllReportsTable.js
 * @author Lateral
 * @since  2023
 */
export const panelName = 'Panel'
export const sideLinerName = 'SideLiner'
export const otherName = 'Other'
